import React from 'react';
import 'normalize.css';
import Header from '../Header';
import LegalPopup from '../LegalPopup';
import HomeFooter from '../HomeFooter';
import s from './Layout.module.scss';
import classNames from 'classnames';
import { Description } from '../../constants/types';

interface LayoutProps {
  currentPage: string;
  children: React.ReactNode;
  layoutStyle?: React.CSSProperties;
  footerDescription?: Description | null;
  pageClass?: string;
}

export default function Layout ({
  children,
  currentPage,
  layoutStyle,
  footerDescription,
  pageClass
}: LayoutProps) {
  return (
    <div className={classNames(s.root, pageClass)}>
      <Header
        currentPage={currentPage}
        layoutStyle={layoutStyle || {}}
      />
      {children}
      <LegalPopup />
      <div className={s.homeFooter}>
        <HomeFooter footerDescription={footerDescription!} />
      </div>
    </div>
  );
};
